import React from 'react';
import './DerivAffiliate.css';

// Deriv affiliate placements.
//
// Three deliberate choices, because an affiliate link done carelessly creates real liability:
//
//   rel="sponsored"  is the value search engines define for paid or affiliate links. Marking
//                    them only "nofollow" (or not at all) is treated as link-scheme
//                    manipulation, which puts the whole domain's ranking at risk — and this
//                    site's traffic is the business.
//
//   Visible disclosure. Most jurisdictions require the commercial relationship to be disclosed
//                    where the link appears, not buried in the footer. It is one short line and
//                    it costs nothing.
//
//   No performance claims. This links to a BROKER. Anything implying an outcome ("start
//                    profiting", "trusted returns") converts a referral into an inducement, and
//                    the terms already state we give no financial advice.

const DERIV_AFFILIATE_URL = 'https://partner-tracking.deriv.com/click?a=41161&o=1&c=3&link_id=1';

export const DERIV_LINK = DERIV_AFFILIATE_URL;

// Inline button — for placing beside existing calls to action.
//
// The rel is written out literally rather than via a constant: the jsx-no-target-blank lint
// rule cannot follow a variable, and silencing it would remove the check that keeps every
// future _blank link safe.
export function DerivAccountButton({ label = 'Open a Deriv account', className = '' }) {
  return (
    <a
      className={`deriv-cta-button ${className}`.trim()}
      href={DERIV_AFFILIATE_URL}
      target="_blank"
      rel="sponsored noopener noreferrer"
    >
      {label}
    </a>
  );
}

/**
 * Full banner. `variant` only changes the supporting copy so each placement explains why a Deriv
 * account is relevant THERE — a generic advert repeated on four pages reads as spam, and the
 * reason genuinely differs by context.
 */
export function DerivAffiliateBanner({ variant = 'default', compact = false }) {
  const copy = {
    // The Builder tests against Deriv's own market data, so this is the most honest placement.
    builder: {
      title: 'Trade these strategies on Deriv',
      body: 'Backtests here run on Deriv market data and real symbol specifications. A Deriv '
        + 'account lets you run the same strategies live on the instruments you tested.',
    },
    signals: {
      title: 'Copy these signals on Deriv',
      body: 'The MT5 copier mirrors signals into any MetaTrader 5 account. Deriv offers MT5 '
        + 'with the synthetic indices and forex pairs these signals trade.',
    },
    product: {
      title: 'Need an MT5 account for this EA?',
      body: 'Every Expert Advisor here runs on MetaTrader 5. Deriv provides MT5 accounts with '
        + 'the symbols and 24/7 synthetic indices these tools are built around.',
    },
    default: {
      title: 'Get started with a Deriv MT5 account',
      body: 'Our tools are built for MetaTrader 5. Deriv provides MT5 accounts covering forex, '
        + 'commodities and 24/7 synthetic indices.',
    },
  }[variant] || {};

  return (
    <aside className={`deriv-banner ${compact ? 'is-compact' : ''}`.trim()}>
      <div className="deriv-banner-body">
        <span className="deriv-banner-kicker">Broker</span>
        <h3>{copy.title}</h3>
        <p>{copy.body}</p>
      </div>
      <div className="deriv-banner-action">
        <DerivAccountButton />
        {/* Disclosure sits WITH the link, not in the footer, which is where disclosure rules
            expect it and where a reader will actually see it. */}
        <small>
          Affiliate link — we may earn a commission at no extra cost to you. Trading involves
          risk of loss.
        </small>
      </div>
    </aside>
  );
}

export default DerivAffiliateBanner;
